import { CheckCircleIcon } from '@heroicons/react/solid'
import React, { useState, useEffect } from 'react';
import { usePage } from '@inertiajs/inertia-react';

export default function Example() {
    const [visible, setVisible] = useState(false);
    const { flash } = usePage().props;

    useEffect(() => {
        setVisible(!!flash.success);
    }, [flash]);

    return (
        <div>
            {visible && (
                <div className="rounded-md bg-green-50 mt-4 p-4">
                    <div className="flex">
                        <div className="flex-shrink-0">
                            <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
                        </div>
                        <div className="ml-3">
                            <h3 className="text-sm font-medium text-green-800">Bericht succesvol verzonden</h3>
                            <div className="mt-2 text-sm text-green-700">
                                <p>Wij streven ernaar om binnen 24 uur te reageren op uw bericht, heeft uw bericht spoed? Bel dan gerust naar ons telefoonnummer.</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>

    )
}
